import { Button, Col, Form } from "react-bootstrap";
import { Link } from "react-router-dom";
import axiosInstance from "../../../axiosInstance";
import "../../../css/newitempage.css"
import React, {Component} from 'react';
class NewProblem extends Component{
    constructor(){
        super();
        this.state = {
            problem: "",
            errors:{
                problem:false,
            },
            modal:false,
            error_messages:{
                problem_error_message:'გთხოვთ შეიყვანოთ პრობლემა',
            },
            response : {
                isValid : false,
                isInValid:false,
                message : 'პრობლემა წარმატებით ჩაემატა'
            }
        }
    }
    onChange(event){
        this.setState(
            {[event.target.name]:event.target.value,
                errors:{
                    ...this.state.errors,
                    [event.target.name]:false 
                },
                response : {
                    isValid : false,
                    isInValid:false,
                    message : 'პრობლემა წარმატებით ჩაემატა'
                }
            }
        ) 
    }

    on_problem_added(data){
        this.setState({
            response:{
                ...this.state.response,
                isValid:true,
                message:data.message
            }
        })
    }
    add_problem_btn_clicked(event){
        this.setState({
            response:{
                ...this.state.response,
                isInValid:false,
                isValid:false,
                message:''
            }
        })
        if(this.valid()){
            var data = new FormData();  
            data.append('problem_name',this.state.problem);
            axiosInstance.post('/problems', data)
            .then(response=>this.on_problem_added(response.data))
            .catch(error => {
                if(error.response.status == 400){
                    this.on_bad_request(error);
                }
            });
        }
    }

    valid(){
        var problem = (this.state.problem === "");
        if(problem){
            this.setState({
                errors:{
                    problem:problem,
                },
            })
            return false;
        }
        return true;
    }

    on_bad_request(error){
        this.setState({
            response:{
                ...this.state.response,
                isInValid:true,
                message:error.response.data.message
            }
        })
    }
    render(){
        return (
            <div className = "content-main">
                <Form.Row>
                        <Form.Group as={Col}  md="4" >
                            <Form.Control
                                    problem="text"
                                    name="problem"
                                    hidden = {true}
                                    isInvalid = {Boolean(this.state.response.isInValid)}
                                    isValid = {Boolean(this.state.response.isValid)}
                                    onChange = {null}
                                />
                            <Form.Control.Feedback type="invalid" >
                                {this.state.response.message}
                            </Form.Control.Feedback>

                            <Form.Control.Feedback >
                                {this.state.response.message}
                            </Form.Control.Feedback>
                        </Form.Group>
                </Form.Row>
                <Form.Row>
                        <Form.Group as={Col}  md="4" >
                            <Form.Label>Problem</Form.Label>
                                <Form.Control
                                    problem="text"
                                    name="problem"
                                    onChange = {(event)=>this.onChange(event)}
                                    isInvalid = {Boolean(this.state.errors.problem)}
                                    value = {this.state.role}
                                />
                                <Form.Control.Feedback problem="invalid" >
                                    {this.state.error_messages.problem_error_message}
                                </Form.Control.Feedback>     
                        </Form.Group>
                </Form.Row>
                <Link  to = "/problems"  id="btn-back" className="btn btn-dark" >უკან დაბრუნება</Link>
                <Button className="btn btn-success"  size="md" onClick={(event)=>this.add_problem_btn_clicked(event)}>დამატება</Button>
            </div>
        )
    }
}
export default NewProblem